<template>
  <div class="setting-container">
    <el-form
      ref="elForm"
      :model="formData"
      :rules="rules"
      size="medium"
      label-width="120px"
      label-position="left"
    >
      <el-card shadow="hover">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <el-form-item label="表单名称" prop="name">
          <el-input
            v-model="formData.name"
            :placeholder="`最多可输入${workConfig.formNameMax}个字`"
            :maxlength="workConfig.formNameMax"
            clearable
            :style="{ width: '100%' }"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="表单图标" prop="icon">
          <img
            :src="activeIconSrc"
            class="active-icon"
            @click="dialogVisible = true"
          />
          <el-button
            plain
            size="mini"
            style="margin-left: 10px;"
            @click="dialogVisible = true"
            >选择图标</el-button
          >
        </el-form-item>
        <el-form-item
          v-if="workConfig.isAdminFlag || workConfig.isCompanyFlag"
          label="项目类型"
          prop="projectType"
          required
        >
          <el-select
            v-model="formData.projectType"
            placeholder="请选择项目类型"
            @change="changeProjectType"
          >
            <el-option
              v-for="(item, index) in workConfig.projectTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属小组" prop="groupId">
          <el-select
            v-model="formData.groupId"
            placeholder="请选择所属小组"
            clearable
          >
            <el-option
              v-for="(item, index) in workConfig.groupList"
              :key="index"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="表单说明" prop="description">
          <el-input
            v-model="formData.description"
            type="textarea"
            placeholder="请输入表单说明"
            :maxlength="100"
            show-word-limit
            :autosize="{ minRows: 4, maxRows: 4 }"
            :style="{ width: '100%' }"
          ></el-input>
        </el-form-item>
      </el-card>
      <el-card shadow="hover">
        <div slot="header" class="clearfix">
          <span>权限设置</span>
        </div>
        <el-form-item label="允许发起的人" prop="idsType">
          <el-select
            v-model="formData.idsType"
            placeholder="请选择"
            @change="changeIdsType"
          >
            <el-option label="所有人" value="all"></el-option>
            <el-option
              v-if="formData.flag === 1"
              label="选择人员"
              :value="0"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.idsType != 'all'">
          <fc-org-select
            ref="org-select"
            v-model="selectIds"
            :companyList="workConfig.companyList"
            buttonType="button"
            type="user"
            title="人员"
            @change="emitInitiator"
          />
        </el-form-item>
        <el-form-item label="允许编辑的人" required>
          <el-select v-model="formData.allowEditor" placeholder="请选择">
            <el-option label="发起人" :value="1"></el-option>
            <el-option label="发起人与全部管理员" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-card>

      <el-card shadow="hover">
        <div slot="header" class="clearfix">
          <span>审批设置</span>
        </div>
        <!-- <el-form-item v-if="workConfig.isAdminFlag" label="表单标识" required>
          <el-select v-model="formData.flag" placeholder="请选择" disabled>
            <el-option label="自定义表单" :value="1"></el-option>
            <el-option label="固定表单" :value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <template v-if="workConfig.isAdminFlag && formData.flag === 2">
          <el-form-item label="权限key" prop="powerKey">
            <el-input
              v-model="formData.powerKey"
              placeholder="请输入权限key"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="PC路由地址" prop="pcRouteUrl">
            <el-input
              v-model="formData.pcRouteUrl"
              placeholder="请输入PC路由地址"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="APP路由地址" prop="appRouteUrl">
            <el-input
              v-model="formData.appRouteUrl"
              placeholder="请输入APP路由地址"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="流程定义key" prop="processDefinitionKey">
            <el-input
              v-model="formData.processDefinitionKey"
              placeholder="请输入流程定义key"
              clearable
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item label="表单类型" prop="formType">
          <el-radio-group v-model="formData.formType" @change="changeFormType">
            <el-radio :label="1">需审批表单</el-radio>
            <el-radio :label="2">无审批表单</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-card>
    </el-form>
    <el-dialog title="选择图标" :visible.sync="dialogVisible" width="612px">
      <img
        v-for="(icon, index) in iconList"
        :key="index"
        :src="icon.src"
        class="icon-item"
        :class="{ active: activeIcon === icon.src }"
        @click="
          activeIcon = icon.src;
          dialogVisible = false;
        "
      />
      <span slot="footer" class="dialog-footer">
        <!-- <el-button
          size="small"
          @click="
            dialogVisible = false;
            selectedIcon = activeIcon;
          "
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="
            dialogVisible = false;
            activeIcon = selectedIcon;
          "
          >确 定</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {},
  props: ["tabName", "initiator", "conf", "workConfig"],
  data() {
    const req = require.context("@/assets/approverIcon", false, /\.png$/);
    const iconList = req.keys().map((t, idx) => ({ src: req(t), id: idx }));
    return {
      dialogVisible: false,
      activeIcon: this.conf.icon || iconList[0].src,
      selectedIcon: this.conf.icon || iconList[0].src,
      selectIds: [], // 选择的人员
      formData: {
        id: this.conf.id || "",
        name: this.conf.name || "",
        icon: this.conf.icon || "",
        groupId: this.conf.groupId || "",
        formType: this.conf.formType,
        allowEditor: this.conf.allowEditor || 2,
        idsType: this.conf.allowInitiatorIds !== "all" ? 0 : "all",
        allowInitiatorIds: this.conf.allowInitiatorIds || "all",
        description: this.conf.description || "",
        flag: this.conf.flag,
        powerKey: this.conf.powerKey || "",
        pcRouteUrl: this.conf.pcRouteUrl || this.conf.powerKey || "",
        appRouteUrl: this.conf.appRouteUrl || "",
        processDefinitionKey: this.conf.processDefinitionKey || "",
        projectType: this.conf.projectType,
        sort: this.conf.sort || 0
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入表单名称",
            trigger: "blur"
          },
          {
            max: this.workConfig.formNameMax,
            message: `最多可输入${this.workConfig.formNameMax}个字`,
            trigger: "blur"
          }
        ],
        icon: [
          {
            required: true,
            message: "请选择表单图标",
            trigger: "change"
          }
        ],
        groupId: [
          {
            required: true,
            message: "请选择所属小组",
            trigger: "change"
          }
        ],
        idsType: [
          {
            required: true,
            message: "请选择允许发起的人",
            trigger: "change"
          }
        ],
        powerKey: [
          {
            required: this.conf.flag === 2,
            message: "请输入权限key",
            trigger: "blur"
          }
        ],
        formType: [
          {
            required: true,
            message: "请选择表单类型",
            trigger: "change"
          }
        ]
      },
      iconList
    };
  },
  computed: {
    activeIconSrc() {
      const icon = this.iconList.find(t => t.src === this.activeIcon);
      return icon ? icon.src : this.iconList[0].src;
    }
  },
  watch: {
    conf(val) {
      this.initSelectIds();
    }
  },
  mounted() {
    this.initSelectIds();
  },
  methods: {
    // 初始化选择的用户
    initSelectIds() {
      let userIds = [];
      let userList = [];
      let targetIdList = [];
      let list = _.cloneDeep(this.workConfig.companyList);
      let selectIds = [];
      const formatArray = array => {
        array.map(e => {
          if (e.organType === this.workConfig.userType) {
            userList.push({
              label: e.label,
              value: e.value,
              key: e.value,
              targetId: e.value
            });
          }
          if (e.children) {
            formatArray(e.children);
          }
        });
      };
      formatArray(list);
      if (typeof this.conf === "object" && this.conf !== null) {
        Object.assign(this.formData, this.conf);
        userIds = this.conf.allowInitiatorIds
          ? this.conf.allowInitiatorIds.split(",")
          : [];
      }
      userList.map(item => {
        if (
          userIds.includes(item.value) &&
          !targetIdList.includes(item.value)
        ) {
          targetIdList.push(item.value);
          selectIds.push(item);
        }
      });
      this.selectIds = selectIds;
      this.initFormData();
      // console.log(
      //   "this.conf--33333",
      //   this.workConfig,
      //   userIds,
      //   userList,
      //   selectIds
      // );
    },
    // 初始化表单数据
    initFormData() {
      this.activeIcon =
        this.conf && this.conf.icon ? this.conf.icon : this.iconList[0].src;
      this.selectedIcon =
        this.conf && this.conf.icon ? this.conf.icon : this.iconList[0].src;
      // console.log("初始化表单数据", this.conf, this.activeIcon);
      this.formData = {
        id: this.conf.id || "",
        name: this.conf.name || "",
        icon: this.conf.icon || this.activeIcon,
        groupId: this.conf.groupId || "",
        formType: this.conf.formType,
        allowEditor: this.conf.allowEditor || 2,
        idsType: this.conf.allowInitiatorIds !== "all" ? 0 : "all",
        allowInitiatorIds: this.conf.allowInitiatorIds || "all",
        allowInitiatorNames: this.conf.allowInitiatorNames || "所有人",
        description: this.conf.description || "",
        flag: this.conf.flag,
        powerKey: this.conf.powerKey || "",
        pcRouteUrl: this.conf.pcRouteUrl || this.conf.powerKey || "",
        appRouteUrl: this.conf.appRouteUrl || "",
        processDefinitionKey: this.conf.processDefinitionKey || "",
        projectType: this.conf.projectType
      };
    },
    changeIdsType(ids) {
      // console.log("changeIdsType", ids);
      if (ids === "all") {
        this.emitInitiator([]);
      }
    },
    emitInitiator(data) {
      this.$nextTick(() => {
        // console.log("emitInitiator", data, this.formData);
        // this.$emit("initiatorChange", { array: data, formData: this.formData });
        this.$emit("initiatorChange", data);
      });
    },
    // 改变项目类型
    changeProjectType(e) {
      this.formData.groupId = "";
      this.$emit("changeProjectType", e);
    },
    // 表单类型改变
    changeFormType() {
      this.$nextTick(() => {
        this.$emit("changeFormType", this.formData.formType);
      });
    },
    // 给父级页面提供得获取本页数据得方法
    getData(isVerify = true) {
      if (this.selectIds.length === 0) {
        this.formData.allowInitiatorIds = "all";
      } else {
        this.formData.allowInitiatorIds = _.map(
          this.selectIds,
          "targetId"
        ).join(",");
      }
      return new Promise((resolve, reject) => {
        this.formData.icon = this.activeIcon;
        if (!isVerify) {
          resolve({ formData: this.formData, target: this.tabName }); // TODO 提交表单
          return;
        }
        this.$refs["elForm"].validate(valid => {
          if (!valid) {
            reject({ target: this.tabName });
            return;
          }
          this.formData.pcRouteUrl =
            this.formData.pcRouteUrl || this.formData.powerKey;
          resolve({ formData: this.formData, target: this.tabName }); // TODO 提交表单
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.grayScale(@width: 100%) {
  -webkit-filter: grayscale(@width);
  -moz-filter: grayscale(@width);
  -ms-filter: grayscale(@width);
  -o-filter: grayscale(@width);
  filter: grayscale(@width);
  filter: gray;
}
.icon-item {
  width: 40px;
  height: 40px;
  margin: 6px;
  position: relative;
  cursor: pointer;
  opacity: 0.4;
  transition: all 0.3s;

  &.active,
  &:hover {
    opacity: 1;
    transform: scale(1.2);
    .grayScale(0) !important;
  }
  &:not(.active) {
    .grayScale();
  }
}

.setting-container {
  width: 750px;
  height: 100%;
  margin: auto;
  background: white;
  padding: 16px;
  .el-card {
    & + .el-card {
      margin-top: 20px;
    }
  }
  > .el-form--label-top .el-form-item__label {
    padding-bottom: 0;
  }
}
.active-icon {
  width: 28px;
  height: 28px;
  vertical-align: middle;
  cursor: pointer;
}
</style>
